<template>
    <b-card no-body>
        <b-card-header class="border-0 popularity-table-headers">
            <div class="popularity-filters">
                <base-input label="Name" placeholder="Name" v-model="filters.name__icontains" />
                <base-input label="Google name" placeholder="Google name" v-model="filters.google_name__icontains" />
                <base-input label="ORG ID" placeholder="ORG ID" v-model="filters.org_id__icontains" />
                <base-input label="Place ID" placeholder="Place ID" v-model="filters.place_id__icontains" />
                <base-input label="Country" placeholder="Country">
                    <b-dropdown v-if="countries!==null" :text="filters.country===undefined  ? 'Not selected' : countries[filters.country].name" variant="outline-light">
                        <b-dropdown-item v-for="(country,index) in countries" :key="index+'_popfilterscountry'" @click="filters.country=country.id;$forceUpdate();getPage(currentPage)">{{country.name}}</b-dropdown-item>
                        <b-dropdown-item @click="filters.country=undefined;$forceUpdate();getPage(currentPage)">Not selected</b-dropdown-item>
                    </b-dropdown>
                </base-input>
            </div>
            <router-link :to="'/popularity/new'">
                <base-button icon type="info">
                    <span class="btn-inner--icon">
                        <i class="ni ni-fat-add"/>
                    </span>
                </base-button>
            </router-link>
        </b-card-header>
        <div v-if="isLoading">
            <card>Loading...</card>
        </div>
        <template v-else>
            <el-table class="table-responsive table"
                    header-row-class-name="thead-light"
                    :data="popularitySites">
                <el-table-column label="ID" prop="id" />
                <el-table-column label="Name" prop="name" />
                <el-table-column label="Country" prop="country" />
                <el-table-column label="Google name" prop="google_name" />
                <el-table-column label="ORG ID" prop="org_id" />
                <el-table-column label="Place ID" prop="place_id" />
                <el-table-column label="Details" prop="_">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center justify-content-end">
                            <router-link v-bind:key="row.id" :to="'/popularity/'+row.id">
                                <base-button icon type="info">
                                    <span class="btn-inner--icon">
                                        <i class="ni ni-align-center"/>
                                    </span>
                                </base-button>
                            </router-link>
                        </b-media>
                    </template>
                </el-table-column>
            </el-table>

            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination v-model="currentPage" :per-page="20" :total="total" @change="pageChanged">
                    <template v-slot:prev-text>
                        <a class="page-link" aria-label="Previous">
                            <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                        </a>
                    </template>
                </base-pagination>
            </b-card-footer>
        </template>
    </b-card>
</template>

<script>
import {Table,TableColumn} from 'element-ui'

import RepositoryFactory from "@/repositories/RepositoryFactory"

const PopularitySiteRepository = RepositoryFactory.get('popularity_site')
const CountryRepository = RepositoryFactory.get('country')

export default {
    name:'popularity-table',
    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
    },
    data(){
        return {
            currentPage:1,
            total:0,
            popularitySites:null,
            lastRequestTimestamp:0,

            filters:{},
            filterTimer:undefined,

            isLoading:true,

            countries:null,
        }
    },
    async created(){
        await this.getCountries();
        this.getPage(this.currentPage);
    },
    watch:{
        filters:{
            handler(oldVal,newVal){
                clearTimeout(this.filterTimer);
                this.isLoading=true;
                for(var i in this.filters){
                    if(this.filters[i]==="")
                        delete this.filters[i]
                    }
                this.filterTimer=setTimeout(() => this.filterTable(), 1000);
            },
            deep:true,
        }
    },
    methods:{
        async getCountries(){
            var r=await CountryRepository.get();
            r=r.data;
            this.countries={}
            for(var i in r){
                var c=r[i]
                this.countries[c.id]=c
            }
        },
        getPage(pageNumber){
            var timestamp=Date.now();
            this.lastRequestTimestamp=timestamp;

            this.isLoading=true;
            this.currentPage=pageNumber;
            PopularitySiteRepository.getTable(pageNumber,this.filters).then((response) => {
                if(this.lastRequestTimestamp!==timestamp) return;

                var r=response.data;
                
                this.popularitySites=r.results;
                this.total=r.count;
                this.currentPage=pageNumber;

                for(var i in this.popularitySites){
                    var countryId=this.popularitySites[i].country;
                    this.popularitySites[i].country=this.countries[countryId].code
                }

                this.isLoading=false;
            })
        },
        pageChanged(pageNumber){
            this.getPage(pageNumber);
        },
        filterTable(){
            this.isLoading=true;
            this.getPage(1);
        }
    }
}
</script>

<style>

.popularity-table-headers {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
}

.popularity-filters{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap:10px;
}

</style>